import store from '@/store'
// import mutationTypes from '@/store/mutationTypes'

export default {
  async getPaymentMethodIdNameList(isHideUnusedPaymentMethod = false) {
    const paymentMethods = isHideUnusedPaymentMethod
      ? await store.dispatch('PaymentMethod/getPaymentMethodListFromApi', {
          isHideUnusedPaymentMethod: 1
        })
      : await store.dispatch('PaymentMethod/getPaymentMethodListFromApi')
    // API実行失敗
    if (!paymentMethods) {
      return {}
    }
    const paymentMethodIdNameList = paymentMethods.data.map((ele) => {
      return { label: ele.name, value: ele.paymentMethodId }
    })
    return {
      code: paymentMethods.code,
      message: paymentMethods.message,
      data: paymentMethodIdNameList
    }
  },
  getPaymentMethodById(id) {
    const list = store.getters['PaymentMethod/getPaymentMethodListFromState']
    const ret = list.find((v) => v.paymentMethodId == id)
    return ret
  },
  getPaymentMethodName(id) {
    const tmp = this.getPaymentMethodById(id)
    return tmp && tmp.name ? tmp.name : '-'
  }
}
